(function () {
    SUGApp.service('portalService', portalService);

    portalService.$inject = ['$injector','SUGUtilities', '$location', '$window', 'globalService', '$q', 'sugCacheFactory', 'httpService', 'globalJSService'];
    function portalService($injector, SUGUtilities, $location, $window, globalService, $q, sugCacheFactory, httpService, globalJSService) {

        var loginfactory;
        if ($injector.has('loginfactory')) {
            loginfactory = $injector.get('loginfactory');
        }

        /**
         * Clears the portal data cached value for a specific portal and section.
         * @param {Integer} portalid
         * @param {Integer} sectionid
         */
        var clearPortalDataCache = function(portalid,sectionid){
            if( portalid ){
                sugCacheFactory.set('portal_' + portalid, undefined);
            }
            if( sectionid ){
                sugCacheFactory.set('portalsection_' + sectionid, undefined);
            }
        };

        /**
         * Gets all the permissions needed to check for portals and caches the result.
         */
        var getPortalPermissions = function() {
            var deferred = $q.defer();
            var portalPerms = {
                'ManagePortals': false,
                'ManageFiles': false,
                'ManageGroups': false
            };
            var portalPermsCachedValue = sugCacheFactory.get('portalPerms',{});

            if( Object.keys(portalPermsCachedValue).length === 0 ){
                service.xhrLoginHandler( "post", "", { "permissioncode": "ManagePortals,ManageFiles,ManageGroups" }, "g.checkPermission", 15000 )
                .then(function (response) {
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if( r.data && r.data.success ){
                        portalPerms = {
                            'ManagePortals': true,
                            'ManageFiles': true,
                            'ManageGroups': true
                        };
                    }else if( r.data && r.data.data.codespassed ){
                        var arrCodesPassed = r.data.data.codespassed.split(',');
                        arrCodesPassed.forEach( function(code){
                            portalPerms[code] = true;
                        });
                    }
                    sugCacheFactory.set('portalPerms',portalPerms);
                    deferred.resolve(portalPerms);
                });
            }else{
                deferred.resolve(portalPermsCachedValue);
            }

            return deferred.promise;
        };

        var getSectionData = function (data,endpoint){
            var deferred = $q.defer();
            var sectionData = data.portalSectionID ? sugCacheFactory.get('portalsection_'+data.portalSectionID,{}) : {};

            if( Object.keys(sectionData).length == 0 ){
                SUGUtilities.APISyncCall('post', '', data, endpoint, 45000).then( function(response){
                    sugCacheFactory.set('portalsection_'+data.portalSectionID,response);
                    deferred.resolve(response);
                }, function(err){
                    deferred.reject(err);
                });
            }else{
                deferred.resolve(sectionData);
            }
            return deferred.promise;
        };

        // define service
        var service = {
            xhrLoginHandler: function (Method, url, data, goAction, timeout) {
                return SUGUtilities.APISyncCall(Method, url, data, goAction, timeout).then(
                    function(response){
                        var r = SUGUtilities.lowerCaseKeys(response.data);
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // check for logged out user
                            if (r.code && r.code == 1002 && loginfactory) {
                                // not logged in
                                service.myLoginInstance = service.myLoginInstance || loginfactory.getLogin(true);
                                return service.myLoginInstance.login(true).then(
                                    function () {
                                        // login succeeded, try to call self again
                                        return service.xhrLoginHandler(Method, url, data, goAction, timeout);
                                    }, function () {
                                        // login failed, just refresh the page and force a login
                                        $window.location.reload();
                                        return {};
                                    }
                                );
                            } else if (r.code && r.code === 1003) {
                                // invalid permission - direct to no access page
                                $window.location.href = '/index.cfm?go=c.NoAccess';
                                return {};
                            } else {
                                // standard error handling, not login/security related error
                                return response;
                            }
                        } else {
                            return response;
                        }
                    }
                );

            },

            /**
             * Method to display an error modal when an Ajax error occurs
             **/
            errorHandler: function (errorObj) {
                var errMessage = SUGUtilities.resultErrorHandler(errorObj);
                if (errMessage.indexOf('Make sure you are logged in and have an active session.') >= 0) {
                    $window.location.reload();
                    return;
                }
                // no longer logged in
                if (errorObj.CODE && errorObj.CODE === 1002) {
                    $window.location.reload();
                    return;
                } else {
                    SUGUtilities.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
                }
            },

             /**
            * method to see if a portal section is the first one of its kind 
            * based on the id given and id expected
            **/
            isFirstPortalSectionByName: function (proposedValue, expectedValue, sectionType){
                return proposedValue.find(pv => pv.sectiontitle === sectionType).id === expectedValue;
            },
            
            // used to verify access
            checkManageAccess: function ( pid ) {
                var deferred = $q.defer();
                var manageSpecificPortal = ( typeof pid !== 'undefined' ) ? sugCacheFactory.get('ManagePortals' + pid, 0) : 0;

                if( manageSpecificPortal === 0 ){
                    // Now that we are calling a local portal permissions method, we need to update all of the check...Access methods
                    getPortalPermissions()
                    .then(function (response) {
                        var r = SUGUtilities.lowerCaseKeys(response);
                        if ( r.manageportals ) {
                            //user has ManagePortals permissions, so continue...

                            //if the user is editing a specific portal page, determine if they own it
                            if( ( typeof pid !== 'undefined' ) ){
                                //Verify that the logged in user owns the portal page they want to edit
                                SUGUtilities.APISyncCall('post', '', {portalId:pid}, 't.memberOwnsPortal', 15000)
                                .then(function (rsp) {
                                    var rr = SUGUtilities.lowerCaseKeys(rsp.data);
                                    if (rr.success) {
                                        //User has permission and this is their portal page to edit :)
                                        deferred.resolve( rr.success );
                                        sugCacheFactory.set('ManagePortals' + pid, true);
                                    } else {
                                        // member doesnt have portal page feature access
                                        if (rr.code && rr.code === 1003) {
                                            $window.location.href = '/index.cfm?go=c.NoAccess';
                                            deferred.reject(false);
                                            sugCacheFactory.set('ManagePortals' + pid, false);
                                        }else{ //member has permission, but this is not their portal page to edit :(
                                            $location.path('/');
                                            deferred.reject(false);
                                            sugCacheFactory.set('ManagePortals' + pid, false);
                                        }
                                    }
                                });

                            } else {
                                //if this is just the list page we only care that they have the permission
                                deferred.resolve( true );
                            }

                        } else {
                            //user does not have ManagePortals permissions
                            //$window.location.href = '/index.cfm?go=c.resourceNotFound&resource=portal';
                            deferred.reject(false);
                        }
                    });

                }else{
                    deferred.resolve(manageSpecificPortal);
                }
                return deferred.promise;
            },
            checkEmailAccess: function () {
                var deferred = $q.defer();
                getPortalPermissions().then(function (response) {
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if ( r.managegroups ) {
                        deferred.resolve(true);
                    } else {
                        deferred.reject(false);
                    }
                });
                return deferred.promise;
            },
            checkGeniusDriveAccess: function () {
                var deferred = $q.defer();
                getPortalPermissions().then(function (response) {
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if ( r.managefiles ) {
                        deferred.resolve(true);
                    } else {
                        deferred.reject(false);
                    }
                });
                return deferred.promise;
            },

            // get portal info - cache result - return cache, else go to the server
            getPortalInfo: function (data, refreshCache) {
                var portalPrefix = 'portal_';
                var portalInfo = sugCacheFactory.get(portalPrefix + data.id);
                if (!refreshCache && typeof portalInfo === 'object' && portalInfo !== null) {
                    // defer to maintain promise, return the portal object
                    var deferred = $q.defer();
                    deferred.resolve( portalInfo );
                    return deferred.promise;
                } else {
                    return SUGUtilities.APISyncCall('post', '', data, 't.getPortalById', 15000)
                        .then(function (response) {
                            var r = SUGUtilities.lowerCaseKeys(response.data.DATA);
                            if( typeof r.portal != 'undefined'){
                                // cache the data
                                sugCacheFactory.set(portalPrefix + r.portal.id, r);
                            }
                            return r;
                        });
                }
            },

            /**
             * Returns the parent Id for a Portal
             * @param {Boolean} blnForceRefresh - optional flag to determine if the value needs to be reloaded or can be returned from cache
             */
            getParentId: function( blnForceRefresh ){
                var deferred = $q.defer();

                //get memberInfo from cache
                var memberInfo = sugCacheFactory.get('memberinfo', {});
                if( Object.keys(memberInfo).length == 0 || blnForceRefresh) {
                    // if nothing is cached, look up live data
                    globalService.getMemberInformation().then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // invalid response, show error
                            deferred.reject( SUGUtilities.getAjaxResponseMessage(response) );
                        } else {
                            // successfully retrieved memberId, set Cache and return it
                            var r = SUGUtilities.lowerCaseKeys(response);
                            memberInfo = r.data.data;
                            // needed for the settings service that also uses this cached data
                            memberInfo.parentID = memberInfo.parentid;
                            sugCacheFactory.set('memberinfo', memberInfo );

                            deferred.resolve(memberInfo.parentid);
                        }
                    });
                } else {
                    deferred.resolve(memberInfo.parentid);
                }
                return deferred.promise;
            },

            /**
             * Generate and return the dynamic CSS using the color scheme values. Used in both the edit and public portal pages.
             * @param {Object} schemeColors - object containing colors for different parts of a portal page
             * @param {String} containerSelector - css selector of html element containing portal content data
             * @param {String} wrapperSelector - css selector of html element wrapping the portal data
             */
            generateSchemeStyles: function(schemecolors, containerSelector, wrapperSelector){
                // if we have an empty schemecolors object return an empty string
                if( SUGUtilities.isUndefinedOrEmptyObject(schemecolors) ){
                    return '';
                }
                containerSelector = SUGUtilities.isDefinedNotNullNotEmpty(containerSelector) ? containerSelector : '';
                wrapperSelector = SUGUtilities.isDefinedNotNullNotEmpty(wrapperSelector) ? wrapperSelector : '';

                //generate the styles
                var schemeStyles =
                    'body ,' +
                    containerSelector + ' {' +
                        'background-color: ' + schemecolors.background + ';' +
                    '} ' +

                    //section headers
                    wrapperSelector + ' .sugportalstyle h1 ,' +
                    wrapperSelector + ' .sugportalstyle h2 ,' +
                    wrapperSelector + ' .sugportalstyle h3 ,' +
                    wrapperSelector + ' .sugportalstyle h4 ,' +
                    wrapperSelector + ' .sugportalstyle h5 ,' +
                    wrapperSelector + ' .sugportalstyle h6 ,' +
                    wrapperSelector + ' .sugportalstyle .h1 ,' +
                    wrapperSelector + ' .sugportalstyle .h2 ,' +
                    wrapperSelector + ' .sugportalstyle .h3 ,' +
                    wrapperSelector + ' .sugportalstyle .h4 ,' +
                    wrapperSelector + ' .sugportalstyle .h5 ,' +
                    wrapperSelector + ' .sugportalstyle .h6 ,' +
                    //advanced-breadcrumb left folder title
                    wrapperSelector + ' .sugportalstyle .crumb--root { ' +
                        'color: ' + schemecolors.headers + ' !important;' +
                    '} ' +

                    wrapperSelector + ' .sugportalstyle a ,' +
                    wrapperSelector + ' .sugportalstyle a:focus ,' +
                    wrapperSelector + ' .sugportalstyle a:hover ,' +
                    wrapperSelector + ' .sugportalstyle a:active ,' +
                    wrapperSelector + ' .sugportalstyle a:visited ,' +
                    ' .sugportalstyle .tool-icon.mono:focus ,' +
                    ' .sugportalstyle .tool-icon.mono:hover , ' +

                    //advanced-breadcrumb left folder title
                    wrapperSelector + ' .sugportalstyle .sug-advanced-breadcrumb .btn:focus .crumb--root,' +
                    wrapperSelector + ' .sugportalstyle .sug-advanced-breadcrumb .btn:hover .crumb--root,' +
                    wrapperSelector + ' .sugportalstyle .sug-advanced-breadcrumb .btn:active .crumb--root,' +

                    //text in advanced-breadcrumb middle folder dropdown text
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:focus .crumb--current, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:hover .crumb--current, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:active .crumb--current, ' +

                    //advanced-breadcrumb middle folder
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:focus .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:hover .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:active .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:focus ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:hover ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:active {' +
                        'color:' + schemecolors.links + ' !important;' +
                    '} ' +

                    //advanced-breadcrumb middle folder number
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:focus .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:hover .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:active .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--number:focus ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--number:hover ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--number:active { ' +
                        'color:#777777 !important;' +
                    '} ' +

                    //advanced-breadcrumb middle folder outline
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:focus .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:hover .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:active .crumb--folder , ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:focus .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:hover .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .btn:active .crumb--number, ' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:focus ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:hover ,' +
                    wrapperSelector + ' .sug-section .sug-advanced-breadcrumb .crumb--folder:active {' +
                        'fill:' + schemecolors.links + ' !important;' +
                    '} ' +

                    // pagination themed
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>a ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>a:focus ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>a:hover ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>a:active ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>a:visited ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>span ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>span:focus ,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>.active>span:hover {' +
                        'color:' + schemecolors.default + ' !important;' +
                        'background-color:' + schemecolors.highlight + ' !important;' +
                    '} ' +

                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>li>a,' +
                    wrapperSelector + ' .sugportalstyle .portal-table .pagination>li>span {' +
                        'background: transparent;' +
                        'border: 1px solid ' + schemecolors.default + '80;' +
                        'color: ' + schemecolors.links + ';' +
                    '} ' +

                    // highlight / accent color on table headers
                    wrapperSelector + ' .sugportalstyle .sug-section-contact ,' +
                    wrapperSelector + ' .sugportalstyle .sug-section-subscribe-nogroups ,' +
                    wrapperSelector + ' .sugportalstyle .sTableSmall.portal-table thead ,' +
                    wrapperSelector + ' .sugportalstyle .sTable.portal-table thead {' +
                        'background-color: ' + schemecolors.highlight + ' !important;' +
                    '} ' +

                    // table bordering
                    wrapperSelector + ' .sugportalstyle .sTable.portal-table {' +
                        'border: none;' +
                    '} ' +
                    wrapperSelector + ' .sugportalstyle .sug-section-files .sTable.portal-table thead,' +
                    wrapperSelector + ' .sugportalstyle .sug-section-files .sTable.portal-table tbody {' +
                        'border: 1px solid ' + schemecolors.default + ' !important;' +
                    '} ' +
                    wrapperSelector + ' .sugportalstyle .sug-section-files .sTable.portal-table thead th a {' +
                        'color: ' + schemecolors.default + ' !important;' +
                    '} ' +
                    /* Bordered rows for sign ups section?
                    wrapperSelector + ' .sugportalstyle .sug-section-signups .sTable.portal-table tr {' +
                        'border: 1px solid ' + schemecolors.highlight + ' !important;' +
                    '} ' + */

                    // table text color
                    wrapperSelector + ' .sugportalstyle .sTable.portal-table tbody {' +
                        'color: ' + schemecolors.default + ';' +
                    '} ' +

                    // tool icons
                    wrapperSelector + ' .sugportalstyle .tool-icon {' +
                        'color: ' + schemecolors.default + ';' +
                    '} ' +
                    wrapperSelector + ' .sugportalstyle .tool-icon.mono:focus,' +
                    wrapperSelector + ' .sugportalstyle .tool-icon.mono:hover' +
                    wrapperSelector + ' .sugportalstyle .tool-icon:focus,' +
                    wrapperSelector + ' .sugportalstyle .tool-icon:hover {' +
                        'color: ' + schemecolors.default + ' !important;' +
                    '} ' +
                    // unselected state
                    wrapperSelector + ' .sugportalstyle .tool-icon.mono {' +
                        'color: ' + schemecolors.default + 'b3;' +
                    '} ' +

                    // portal dividers
                    ' .sugportalstyle .portal-divider ,' +
                    wrapperSelector + ' .portal-divider {' +
                        'background-color: ' + (SUGUtilities.lightOrDark(schemecolors.background) ? 'rgba(102,102,102,0.15)' : 'rgba(235,235,235,0.1)') + ' !important;' +
                    '} ' +

                    // dropdown form control - not themed
                    wrapperSelector + ' .bootstrap-select .dropdown-menu a ,' +
                    wrapperSelector + ' .bootstrap-select .dropdown-menu a:focus ,' +
                    wrapperSelector + ' .bootstrap-select .dropdown-menu a:hover ,' +
                    wrapperSelector + ' .bootstrap-select .dropdown-menu a:active ,' +
                    wrapperSelector + ' .bootstrap-select .dropdown-menu a:visited {' +
                        'color: inherit !important;' +
                    '} ' +

                    // settings/gear menu from controls not themed
                    wrapperSelector + ' .dropdown-menu.settingsOption label {' +
                        'color: inherit !important;' +
                    '} ' +

                    // default text color
                    wrapperSelector + ' .sugportalstyle div .sug-portal-desc ,' +
                    wrapperSelector + ' .sugportalstyle label ,' +
                    wrapperSelector + ' .sugportalstyle .empty-message ,' +
                    wrapperSelector + ' .sug-section-contact {' +
                        'color: ' + schemecolors.default + ' !important;' +
                    '} ' +

                    // default text color with opacity reduction
                    wrapperSelector + ' .sugportalstyle .smalltextlite ,' +
                    wrapperSelector + ' .sug-section-signups .signup-group,' +
                    wrapperSelector + ' .sug-section-signups .signup-slots,' +
                    wrapperSelector + ' .sugportalstyle .text-muted {' +
                        'color: ' + schemecolors.default + 'b3 !important;' +
                    '} ' +

                    // btn-themed themed
                    wrapperSelector + ' .btn-themed {' +
                        'border: 1px solid rgba(0,0,0,0.1);' + // this may become a themed color, so putting it here
                    '} ' +
                    wrapperSelector + ' .btn-themed ,' +
                    wrapperSelector + ' .btn-themed:active ,' +
                    wrapperSelector + ' .btn-themed:focus ,' +
                    wrapperSelector + ' .btn-themed:hover {' +
                        'background-color: ' + schemecolors.highlight + ' !important;' +
                        'color: ' + schemecolors.default + ' !important;' +
                    '} ' +
                    wrapperSelector + ' .btn-themed:focus ,' +
                    wrapperSelector + ' .btn-themed:hover {' +
                        'background-color: ' + schemecolors.highlight + 'e6 !important;' +
                        'color: ' + schemecolors.default + 'e6 !important;' +
                    '} ' +
                    // no brand footer text
                    '.nb-copyright-text {' +
                        'color: ' + schemecolors.default + ' !important;' +
                    '} ' +
                    // no brand footer links
                    '.nb-links {' +
                        'color: ' + schemecolors.links + ' !important;' +
                    '} ' +
                    //apply color to custom portal spinner. Robert specified always sug orange.
                    //original implementation used scheme link color: schemecolors.links
                    wrapperSelector + ' .sug-spinner div {' +
                        'background: #f68b1c !important;' +
                    '} ' +

                    //Allows us to enforce an orange SUG link inside a color scheme area
                    wrapperSelector + ' .sugportalstyle a.sug-link , .sugportalstyle a.sug-link:visited {' +
                        'color: #f68b1c !important;' +
                    '} ' ;

                return schemeStyles;
            },

            // BEGIN API calls //
            getPortalById: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.getPortalById', 15000);
            },
            getPortalsByMemberID: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.getPortalsByMemberID', 30000);
            },
            hasEmbedPortalFeature: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.hasEmbedPortalFeature', 15000);
            },

            savePortal: function (data) {
                clearPortalDataCache(data.id);
                return service.xhrLoginHandler('post', '', data, 't.savePortal', 15000);
            },
            deletePortal: function (data) {
                clearPortalDataCache(data.id);
                return service.xhrLoginHandler('post', '', data, 't.deletePortal', 15000);
            },

            getPortalColorSchemeByMemberID: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.getPortalColorSchemeByMemberID', 15000);
            },

            savePortalColorScheme: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.savePortalColorScheme', 15000);
            },

            deletePortalColorScheme: function (data) {
                // Commented out because we don't have a way of using this in our XD doc, but included because the code exists.
                //return service.xhrLoginHandler('post', '', data, 't.deletePortalColorScheme', 15000);
                return;
            },
            getSections: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.getSections', 15000);
            },
            savePortalSection: function (data) {
                clearPortalDataCache(data.portalID,data.ID);
                return service.xhrLoginHandler('post', '', data, 't.savePortalSection', 15000);
            },
            deletePortalSection: function (data) {
                clearPortalDataCache(data.portalID,data.ID);
                return service.xhrLoginHandler('post', '', data, 't.deletePortalSection', 15000);
            },
            verifyPortalUrlKey: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.verifyPortalUrlKey', 15000);
            },
            loadPortalSectionData: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.loadPortalSectionData', 15000);
            },
            loadContactData: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.loadContactData', 15000);
            },
            getBannerSectionData: function (data){
                return getSectionData(data,'c.getBannerSectionData');
            },
            getSignupSectionData: function (data) {
                return getSectionData(data,'c.getSignupSectionData');
            },
            getImageCategories: function(data) {
                return httpService.post(globalJSService.apiendpoint + '/tools/imageCategories/', data);
            },
            getImagesByCategory: function(data) {
                return httpService.post(globalJSService.apiendpoint + '/tools/imagesByCategory/', data);
            },
            memberCustomImages: function (data) {
                return httpService.post(globalJSService.apiendpoint + '/tools/memberCustomImages/', data);
            },
            memberOwnsPortal: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.memberOwnsPortal', 15000);
            },
            //From wizard
            processImageUpload: function (data) {
                return service.xhrLoginHandler('post', '', data, 'w.processImageUpload', 60000);
            },
            deleteMemberImage: function (data) {
                return service.xhrLoginHandler('post', '', data, 'w.deleteMemberImage', 30000);
            },
            getAddedFileInfo: function (data) {
                return service.xhrLoginHandler('post', '', data, 't.getAddedFileInfo', 15000);
            },

            /** PUBLIC Page Methods */
            getPortalByUrl_Public: function (data) {
                return SUGUtilities.APISyncCall('post', '', data, 'c.getPortalByUrl', 15000);
            },
            getSubscribeSectionData_Public: function (data) {
                return getSectionData(data,'c.getSubscribeSectionData');
            },
            subscribeUserToGroups_Public: function (data) {
                return SUGUtilities.APISyncCall('post', '', data, 'c.subscribeUserToGroups', 15000);
            },
            getFilesSectionData_Public: function (data) {
                return getSectionData(data,'c.getFilesSectionData');
            },

            /** EMBED Page Methods */
            getPortalEmbedData: function (data) {
                return getSectionData(data,'c.getPortalEmbedData');
            }
        };

        return service;
    }
}());
